import { render, staticRenderFns } from "./categorySlider.vue?vue&type=template&id=d1f74d36&scoped=true&lang=pug&"
import script from "./categorySlider.vue?vue&type=script&lang=js&"
export * from "./categorySlider.vue?vue&type=script&lang=js&"
import style0 from "./categorySlider.vue?vue&type=style&index=0&id=d1f74d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f74d36",
  null
  
)

export default component.exports